import { Injectable } from '@angular/core'
import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { TrainingListData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingListConverter extends CmsConverterService<TrainingListData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      categories: formData.st_csod_categories?.value?.map((v: any) => {
        const { categoryId, categoryTitle } = v.value.target.dataset
        return { categoryId: `${categoryId}`, categoryTitle }
      }),
      backgroundColor: formData.st_backgroundcolor?.value,
    }
  }
}
